export default "__VITE_ASSET__Qls3K00x__"